import type { ExpenseEntry } from "web_myplann/Finances/Types/ExpenseEntry";
import {
	ClientFinancialPlanExpenseNameEnum,
	type ClientFinancialPlanExpenseTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const findReplacedTotalIndex = (
	expenses: ExpenseEntry[],
	type: ClientFinancialPlanExpenseTypeEnum,
	addedName: ClientFinancialPlanExpenseNameEnum,
) =>
	addedName === ClientFinancialPlanExpenseNameEnum.Total
		? -1
		: expenses.findIndex(
				(expense) =>
					expense.type === type &&
					expense.name === ClientFinancialPlanExpenseNameEnum.Total,
			);
